import React, { useEffect, useState } from 'react';
import Display from './Display';
import { useParams, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFiltr, setCheckenFiltr, setFiltr, getFiltersUrl } from '../../redux/filtercatalog-reduser.js';
import { getCatalogItems, setCurrentPage, getCatalogItemsFish, getBasketIdItemsFish, getCatalogItemsMoby } from '../../redux/catologItems-reducer.js';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
    getCatalogItemsSelect, getCheckedFiltr, getCountFiltrItems, getCurrentPage, getFilters,
    getFiltrOptionSort, getFiltrUrl, getIsFetchingFilter, getPageSize, getPriceFiltrItems, getTotalItemsCatolog,
    getIsFetchingItems, getPriceFiltrItemsMaxMin, getIsFetchingItemsMoby,
    getValueSelected, getBasketItemsId, getTagCloudFiltr, getisFetchingSelect, getCatalogPageUrl
} from '../../redux/filter-selectors';
import { getValueSelectedUrl, getFiltrSelectedAC } from '../../redux/filtersort-reduser';


export const paramsQuerryChekerUrl = (props) => {
    const checked = [];
    if (props.params.location.search != "") {

        props.paramsQuerry.paramsQuerry.map((getpar, i) => {
            let filtr = getpar[0].split(/^(.+)+\[(.+)+\](.+)+/gm)[1];
            let filtrSort = getpar[0];
            let filtrSortValue = getpar[1];
            let filtrGetParamsKey = getpar[0].split(/^(.+)+\[(.+)+\](.+)+/gm)[2];
            let filtrGetParamsValue = String(getpar[1]);

            if (filtr == 'filter') {

                if (checked.hasOwnProperty(filtrGetParamsKey)) {
                    let currentIndex = checked[filtrGetParamsKey].indexOf(filtrGetParamsValue);
                    if (currentIndex === -1) {
                        checked[filtrGetParamsKey].push(filtrGetParamsValue);
                    } else {
                        checked[filtrGetParamsKey].splice(currentIndex, 1);
                    }


                }
                else {
                    if (filtrGetParamsKey != "")
                        checked[filtrGetParamsKey] = [filtrGetParamsValue];
                }

            }

        })


    }


    return checked;
}

export const paramsQuerryChekerUrlTagNameCloud = (props) => {

    const tagNameCloud = []; const valueCloud = []; var filtrPriceUrl = ''; var nameTitlePrice = ""; var intPrice = 0;
    var nameTitleMartindale = ""; var intMartindale = 0; var filtrMartindaleUrl = '';
    var nameTitleWidth = ""; var intWidth = 0; var filtrWidthUrl = '';
    if (props.params.location.search != "") {
        props.paramsQuerry.paramsQuerry.map((getpar, ii) => {
            let filtr = getpar[0].split(/^(.+)+\[(.+)+\](.+)+/gm)[1];
            let filtrSort = getpar[0];
            let filtrSortValue = getpar[1];
            let filtrGetParamsKey = getpar[0].split(/^(.+)+\[(.+)+\](.+)+/gm)[2];
            let filtrGetParamsValue = Number(getpar[1]);

            if (filtrSort == "tag") {

                tagNameCloud[ii] = { name: `${filtrSortValue}`, url: `${filtrSort}=${filtrSortValue}`, code: filtrGetParamsKey, value: filtrSortValue };
            }

            if (props.checked.hasOwnProperty(filtrGetParamsKey)) {
                if (filtrGetParamsKey == "class") {

                    tagNameCloud[ii] = { name: `Только распродажа`, url: `${filtrSort}=${filtrSortValue}`, code: filtrGetParamsKey, value: filtrSortValue };
                }
                if (filtrGetParamsKey == "price") {

                    if (intPrice < 2) {
                        filtrPriceUrl = filtrPriceUrl + `${filtrSort}=${filtrSortValue}&`;
                        nameTitlePrice = nameTitlePrice + `${filtrSortValue}-`;

                    }
                    intPrice++;
                    if (nameTitlePrice.substring(nameTitlePrice.length - 1) == "-" && intPrice == 2) {
                        nameTitlePrice = nameTitlePrice.substring(0, nameTitlePrice.length - 1);
                    }
                    if (filtrPriceUrl.substring(filtrPriceUrl.length - 1) == "&" && intPrice == 2) {
                        filtrPriceUrl = filtrPriceUrl.substring(0, filtrPriceUrl.length - 1);
                    }
                    if (intPrice == 2) {
                        tagNameCloud[ii] = { name: `Цена ${nameTitlePrice}`, url: filtrPriceUrl, code: filtrGetParamsKey, value: nameTitlePrice };
                    }
                }
                if (filtrGetParamsKey == "martindale") {

                    if (intMartindale < 2) {
                        filtrMartindaleUrl = filtrMartindaleUrl + `${filtrSort}=${filtrSortValue}&`;
                        nameTitleMartindale = nameTitleMartindale + `${filtrSortValue}-`;

                    }
                    intMartindale++;
                    if (nameTitleMartindale.substring(nameTitleMartindale.length - 1) == "-" && intMartindale == 2) {
                        nameTitleMartindale = nameTitleMartindale.substring(0, nameTitleMartindale.length - 1);
                    }
                    if (filtrMartindaleUrl.substring(filtrMartindaleUrl.length - 1) == "&" && intMartindale == 2) {
                        filtrMartindaleUrl = filtrMartindaleUrl.substring(0, filtrMartindaleUrl.length - 1);
                    }
                    if (intMartindale == 2) {
                        tagNameCloud[ii] = { name: `Тест Мартиндейла ${nameTitleMartindale}`, url: filtrMartindaleUrl, code: filtrGetParamsKey, value: nameTitleMartindale };
                    }
                }
                if (filtrGetParamsKey == "width") {

                    if (intWidth < 2) {
                        filtrWidthUrl = filtrWidthUrl + `${filtrSort}=${filtrSortValue}&`;
                        nameTitleWidth = nameTitleWidth + `${filtrSortValue}-`;

                    }
                    intWidth++;
                    if (nameTitleWidth.substring(nameTitleWidth.length - 1) == "-" && intWidth == 2) {
                        nameTitleWidth = nameTitleWidth.substring(0, nameTitleWidth.length - 1);
                    }
                    if (filtrWidthUrl.substring(filtrWidthUrl.length - 1) == "&" && intWidth == 2) {
                        filtrWidthUrl = filtrWidthUrl.substring(0, filtrWidthUrl.length - 1);
                    }
                    if (intWidth == 2) {
                        tagNameCloud[ii] = { name: `Ширина ${nameTitleWidth}`, url: filtrWidthUrl, code: filtrGetParamsKey, value: nameTitleWidth };
                    }
                }
                props.filterItems.map((get, i) => {
                    if (get.CODE == filtrGetParamsKey && get.DISPLAY_TYPE == "F") {

                        get.PROPERTY_VALUE.map((getPropValue, i) => {
                            if (filtrGetParamsValue == getPropValue.ID) {

                                tagNameCloud[ii] = { name: `${getPropValue.nameValeu}`, url: `${filtrSort}=${filtrSortValue}`, code: filtrGetParamsKey, value: filtrSortValue };


                            }
                        });
                    }
                    if (get.CODE == filtrGetParamsKey && get.DISPLAY_TYPE == "G" && filtrSortValue !== "NaN") {
                        tagNameCloud[ii] = { name: `ЦВЕТ #${filtrSortValue}`, url: `${filtrSort}=${filtrSortValue}`, code: filtrGetParamsKey, value: filtrSortValue };
                    }

                });
            };
        });

    }


    return tagNameCloud;
}

export const paramsQuerryChekerUrlSelect = (props) => {

    var filtrSortUrl = ''; var intSort = 0;
    if (props.params.location.search != "") {

        props.paramsQuerry.paramsQuerry.map((getpar, i) => {

            let filtrSort = getpar[0];
            let filtrSortValue = getpar[1];

            if (filtrSort == 'sort_by' || filtrSort == 'sort_dir') {
                if (intSort < 2) {
                    if (filtrSort == 'sort_dir') { filtrSortValue = filtrSortValue.toLowerCase(); }
                    filtrSortUrl = filtrSortUrl + `${filtrSort}=${filtrSortValue}&`;

                }
                intSort++;
            }
        })


    }




    if (filtrSortUrl.substring(filtrSortUrl.length - 1) == "&") {
        filtrSortUrl = filtrSortUrl.substring(0, filtrSortUrl.length - 1);
    }

    if (filtrSortUrl == "") { filtrSortUrl = props.valueSelected }
    return filtrSortUrl;
}

export const paramsQuerryChekerUrlTagName = (props) => {

    var tagname = ""; var intSort = 0; let tagbr = "";
    if (props.params.location.search != "") {

        props.paramsQuerry.paramsQuerry.map((getpar, i) => {

            let filtrTagname = getpar[0];
            let filtrTagnameValue = getpar[1];

            if (filtrTagname == 'tagname' || filtrTagname == "tag") {
                tagbr = "taggood";
                tagname = filtrTagnameValue;
                return tagname;
            }

        }
        )
        if (tagbr !== "taggood") { tagname = ''; }
    } else { tagname = ''; }

    // console.log("tagbr",tagbr,"tagname",tagname)
    return tagname;
}

export const paramsQuerryPageCurentUrl = (props) => {

    var PageNameUrl;
    if (props.params.location.search != "") {

        props.paramsQuerry.paramsQuerry.map((getpar, i) => {

            let filtrPageName = getpar[0];
            let filtrPageNameValue = getpar[1];

            if (filtrPageName == 'page') {
                props.setCurrentPage(Number(filtrPageNameValue));
                PageNameUrl =  Number(filtrPageNameValue);
            }

        }
        )
    } else {
     PageNameUrl = Number(props.currentPage);
    }
   return  PageNameUrl;
}

export const withRouter = WrappedComponent => props => {
    let [searchParams, setSearchParams] = useSearchParams();


    const paramsQuerry = [];

    for (let entry of searchParams.entries()) {
        paramsQuerry.push(entry);
    }
    //console.log("getAll",searchParams);
    // console.log(paramsQuerry); // [["page", 5], ["pageSize", 25]]

    let params = useParams();
    let navigate = useNavigate();
    let location = useLocation();


    // etc... other react-router-dom v6 hooks
    return (
        <WrappedComponent
            {...props}
            params={{ params, navigate, location, searchParams }}
            paramsQuerry={{ paramsQuerry }}
        // etc...
        />
    );

}
export const paramsQuerryChekerDataUrlFiltr = () => {
    if(document.getElementById('root').getAttribute('data-urlFiltr') != ""){
        let urlFiltr = document.getElementById('root').getAttribute('data-urlFiltr');
        const paramsQuerryData = [];
       let arrayUrl = urlFiltr.split("&");
       let mapRezUrl = arrayUrl.map((arrayUrl_) =>{
        let u = arrayUrl_.split("=");
        paramsQuerryData.push(...paramsQuerryData, [u[0],u[1]])
       })

       var uniqueArr = paramsQuerryData.filter(function(value, index, self) {
        return self.findIndex(function(item) {
          return item[0] === value[0] && item[1] === value[1];
        }) === index;
      });


       return  uniqueArr;   
    }
}

export const paramsQuerryChekerUrlData = (dataProps) => {
    const checked = [];


    dataProps.map((getpar, i) => {
            let filtr = getpar[0].split(/^(.+)+\[(.+)+\](.+)+/gm)[1];
            let filtrSort = getpar[0];
            let filtrSortValue = getpar[1];
            let filtrGetParamsKey = getpar[0].split(/^(.+)+\[(.+)+\](.+)+/gm)[2];
            let filtrGetParamsValue = String(getpar[1]);

            if (filtr == 'filter') {

                if (checked.hasOwnProperty(filtrGetParamsKey)) {
                    let currentIndex = checked[filtrGetParamsKey].indexOf(filtrGetParamsValue);
                    if (currentIndex === -1) {
                        checked[filtrGetParamsKey].push(filtrGetParamsValue);
                    } else {
                        checked[filtrGetParamsKey].splice(currentIndex, 1);
                    }


                }
                else {
                    if (filtrGetParamsKey != "")
                        checked[filtrGetParamsKey] = [filtrGetParamsValue];
                }

            }

        })





    return checked;
}

const DisplayComponent = (props) => {

    useEffect(() => {

        if (props.params.location.search != "") {

            let urlFiltr = props.params.location.search.trim().slice(1);

            props.getCatalogItems(props.pageSize, paramsQuerryPageCurentUrl(props), "&" + urlFiltr);
            props.setFiltr("?" + urlFiltr);
            
            props.getFiltersUrl(urlFiltr);
            props.setCheckenFiltr(paramsQuerryChekerUrl(props));

        } else {
            if(document.getElementById('root').getAttribute('data-urlFiltr') != ""){
                let urlFiltr = document.getElementById('root').getAttribute('data-urlFiltr');
                props.getCatalogItems(props.pageSize, paramsQuerryPageCurentUrl(props), "&" + urlFiltr);
                props.setFiltr("?" + urlFiltr);
                props.getFiltersUrl(urlFiltr);
                props.setCheckenFiltr(paramsQuerryChekerUrlData(paramsQuerryChekerDataUrlFiltr()));
            }else{

                props.getFiltr();
                props.getCatalogItems(props.pageSize, props.currentPage);
                
            }
            
            props.getBasketIdItemsFish();

        }

        
    }, [])

    return (
        <Display {...props} />
    )

}


let f1 = (store) => {
    return {
        filterItems: getFilters(store),
        isFetchingFilter: getIsFetchingFilter(store),
        checked: getCheckedFiltr(store),
        catologItems: getCatalogItemsSelect(store),
        pageSize: getPageSize(store),
        totalItemsCount: getTotalItemsCatolog(store),
        currentPage: getCurrentPage(store),
        countItems: getCountFiltrItems(store),
        getPriceSlideMaxMin: getPriceFiltrItemsMaxMin(store),
        getPriceSlide: getPriceFiltrItems(store),
        filterSort: getFiltrOptionSort(store),
        getUrlFiltr: getFiltrUrl(store),
        valueSelected: getValueSelected(store),
        basketitemsId: getBasketItemsId(store),
        isFetchingItems: getIsFetchingItems(store),
        isFetchingItemsMoby: getIsFetchingItemsMoby(store),
        isFetchingSelect: getisFetchingSelect(store),
        tagCloudFiltr: getTagCloudFiltr(store),
        catalogUrl: getCatalogPageUrl(store),
    }
}

export default compose(
    connect(f1, {
        getFiltr, getCatalogItems, setCheckenFiltr, getValueSelectedUrl, getCatalogItemsMoby,
        setFiltr, setCurrentPage, getFiltersUrl, getCatalogItemsFish, getBasketIdItemsFish, getFiltrSelectedAC
    }),
    withRouter
)(DisplayComponent);